import React, { Component } from "react";
import axios from "axios";
import Select from "react-select";
import './Header.scss';
import MyContext from '../MyContext.jsx';

class Header extends Component {
  constructor(props) {
    super(props);
    // this.props.history.replace('/');
    // this.state = {
    //   divisions : '',
    //   division : []
    // }
    this.divisionChange = this.divisionChange.bind(this);
  }

  componentDidMount(){ 
    var obj_this = this;
    $("#root").on("click",".logout_button", function(){
      if(!confirm("Are you sure you want to logout?")){
        return;
      }
      obj_this.context.loading(1);
      window.localStorage.removeItem("alsafas_emak_customers_cache");
      window.localStorage.removeItem("alsafas_emak_customers_cache_expiry");
      var user_details = window.localStorage.getItem("user_details_alsafas_emak_app");
      console.log(user_details);

      var performHardLogout = function() {
        window.sessionStorage.clear();
        
        var promises = [];
        
        if (window.caches) {
          promises.push(
            window.caches.keys().then(function(keys) {
              return Promise.all(keys.map(function(key) {
                return window.caches.delete(key);
              }));
            })
          );
        }
        if (navigator.serviceWorker) {
          promises.push(
            navigator.serviceWorker.getRegistrations().then(function(registrations) {
              return Promise.all(registrations.map(function(registration) {
                return registration.unregister();
              }));
            })
          );
        }
        
        Promise.all(promises).then(function() {
          window.location.href = window.location.origin + window.location.pathname + "?t=" + Date.now();
        }).catch(function() {
          window.location.href = window.location.origin + window.location.pathname + "?t=" + Date.now();
        });
      };

      const url = `${process.env.REACT_APP_SSS}/api/logout`;
      $.ajax({
        url : url,
        data : {
          user_details : user_details
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        if(return_data.status == "success"){
          alert("Logged out successfully");
          obj_this.context.setUserDetails({});
          user_details = JSON.parse(user_details);
          user_details.sid = "";
          // console.log(user_details);
          window.localStorage.setItem("user_details_alsafas_emak_app",JSON.stringify(user_details));
          performHardLogout();
        }else{
          alert("Network error!!");
          performHardLogout();
        }
        obj_this.context.loading(0);
      }).fail(function(){
          alert("Network error!!");
          performHardLogout();
      });
    });
    // cordova.plugins.locationAccuracy.request(function(){console.log("location success")}, function(){"location error"});
  }

  divisionChange(option){
    if(option.value == this.context.user_details.division.value){
      return;
    }
    if(!confirm("Are you sure, Change division to "+option.label+" ?")){
      return;
    }
    window.localStorage.removeItem("alsafas_emak_customers_cache");
    window.localStorage.removeItem("alsafas_emak_customers_cache_expiry");
    var obj_this = this;
    this.context.loading(1);
    $.ajax({
      url : process.env.REACT_APP_SSS + "/api/changeDivision",
      data : {
        division: option,
        sid : this.context.user_details.sid,
        username : this.context.user_details.username,
        password : this.context.user_details.password,
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        delete return_data.status;
        return_data.division = option;
        obj_this.context.setUserDetails(return_data);
        window.localStorage.setItem("user_details_alsafas_emak_app",JSON.stringify(return_data));
        obj_this.props.history.replace('/dashboard');
        // obj_this.props.history.replace('/home');
      }else{
        alert("You are not authorized to access");
      }
      obj_this.context.loading(0);
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  render(){
  const {pathname} = this.props.location;
  if(pathname === "/android_asset/www/index.html" || pathname === "/") {
    return null;
  }
  return (
    <MyContext.Consumer>
      {context => (
        <div className="header_container">
          {/* <div className="app_name">E-MAK Pro</div> */}
          <img className="app_name" src={window.project_path+"/images/company_logo.png"} height="50px;" />

          <div className="name_division_container">
            <div className="username">Hello, {this.context.user_details.fullname}</div>
            {/*<div className="division">{this.context.user_details.division}</div>*/}
            <div className="division">
              <Select className="division_select"
                options={this.context.user_details.divisions}
                value={this.context.user_details.division}
                onChange={this.divisionChange}
                isSearchable={false}
              />
            </div>
          </div>
          <div className="zoom_button" onClick={() => context.setMagnified(!context.magnified)}>
            <i className={`fa ${context.magnified ? "fa-search-minus" : "fa-search-plus"}`} style={{padding:"10px"}}></i>
          </div>
          <div className="logout_button">
            <i className="fa fa-sign-out-alt" style={{padding:"10px"}}></i>
          </div>
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Header;
Header.contextType = MyContext;

